import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Target, Shield, Eye, Zap, Lock, Layers } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function FeatureGrid() {
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const modules = [{
    icon: <Target className="w-6 h-6" data-id="element-44" />,
    title: 'Marcos de Control',
    desc: 'Establece las reglas invisibles de cada interacción desde el segundo cero.'
  }, {
    icon: <Shield className="w-6 h-6" data-id="element-45" />,
    title: 'Defensa Cognitiva',
    desc: 'Protegé tu marco ante intentos de manipulación y ataques pasivo-agresivos.'
  }, {
    icon: <Eye className="w-6 h-6" data-id="element-46" />,
    title: 'Lectura de Patrones',
    desc: 'Detectá las estructuras ocultas y motivaciones reales en cada conversación.'
  }, {
    icon: <Zap className="w-6 h-6" data-id="element-47" />,
    title: 'Activadores Mentales',
    desc: 'Disparadores psicológicos de acción inmediata para vencer la resistencia.'
  }, {
    icon: <Lock className="w-6 h-6" data-id="element-48" />,
    title: 'Anclaje Estratégico',
    desc: 'Fijá puntos de referencia subconscientes que guíen las decisiones a tu favor.'
  }, {
    icon: <Layers className="w-6 h-6" data-id="element-49" />,
    title: 'Arquitectura de Influencia',
    desc: 'Construí sistemas de persuasión multicapa para negociaciones complejas.'
  }];
  return <SectionWrapper className="bg-bg" data-id="element-50">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={staggerContainer} data-id="element-51">
        <div className="text-center mb-16" data-id="element-52">
          <motion.h2 variants={fadeUp} className="font-heading text-3xl md:text-4xl font-black text-text-primary uppercase tracking-tight mb-4" data-id="element-53">
            Módulos de Aplicación Directa
          </motion.h2>
          <motion.p variants={fadeUp} className="font-body text-xl text-text-secondary" data-id="element-54">
            Sin relleno, pura ejecución.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-55">
          {modules.map((mod, idx) => <motion.div key={idx} variants={fadeUp} className="bg-surface border border-border p-8 rounded-xl hover:border-accent/40 transition-all duration-300 group" data-id="element-56">
              <div className="mb-6 text-accent opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 origin-left" data-id="element-57">
                {mod.icon}
              </div>
              <h3 className="font-heading font-bold text-lg text-text-primary mb-3" data-id="element-58">
                {mod.title}
              </h3>
              <p className="font-body text-sm text-text-secondary leading-relaxed" data-id="element-59">
                {mod.desc}
              </p>
            </motion.div>)}
        </div>
      </motion.div>
    </SectionWrapper>;
}